import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LogDto, LoggerServiceClient } from '@sharedrest/technical.restservice';
import { environment } from '@sharedenvironment';

export abstract class LoggerService {

  constructor(private readonly loggerServiceClient: LoggerServiceClient) {
  }

  abstract appCode(): string;

  debug(code: string, message: string) {
    if (!environment.production) {
      // tslint:disable-next-line:no-console
      console.debug(message);
    }
    this.log('DEBUG', code, message);
  }

  info(code: string, message: string) {
    if (!environment.production) {
      // tslint:disable-next-line:no-console
      console.info(message);
    }
    this.log('INFO', code, message);
  }

  warn(code: string, message: string) {
    console.warn(message);
    this.log('WARN', code, message);
  }

  error(code: string, message: string) {
    console.error(message);
    this.log('ERROR', code, message);
  }

  private async log(level: string, code: string, message: string) {
    const log = new LogDto();
    log.app = this.appCode();
    log.code = code;
    log.message = message;
    log.level = level;
    await lastValueFrom(this.loggerServiceClient.create(log).pipe(
      catchError((_: any): Observable<any> => {
        // Do nothing if an error occurs with the logger service
        console.error('Unable to log the error');
        return of();
      })
    ));
  }
}

@Injectable()
export class UserLoggerService extends LoggerService {

  appCode(): string {
    return 'user';
  }
}

@Injectable()
export class AdminLoggerService extends LoggerService {

  appCode(): string {
    return 'admin';
  }
}
